    import { Group, MeshStandardMaterial, Vector2, Vector3, TextureLoader, CanvasTexture, MeshBasicMaterial, PlaneGeometry, Color, Raycaster } from 'three'
    import glsl from 'glslify'
    import assets from '../utils/AssetManager'
    import { addUniforms, customizeVertexShader } from '../utils/customizeShader'
    // Removed GUI import
    // import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js'
    
    const suzanneKey = assets.queue({
      url: 'assets/money-wrap.gltf',
      type: 'gltf',
    })
    
    const albedoKey = assets.queue({
      url: 'assets/spotty-metal/albedo.jpg',
      type: 'texture',
      gamma: true,
    })
    const metalnessKey = assets.queue({
      url: 'assets/spotty-metal/metalness.jpg',
      type: 'texture',
    })
    const roughnessKey = assets.queue({
      url: 'assets/spotty-metal/roughness.jpg',
      type: 'texture',
    })
    const normalKey = assets.queue({
      url: 'assets/spotty-metal/normal.jpg',
      type: 'texture',
    })
    
    const hdrKey = assets.queue({
      url: 'assets/ouside-afternoon-blurred-hdr.jpg',
      type: 'env-map',
      gamma: true,
    })
    
    export default class Suzanne extends Group {
      constructor(webgl, options = {}) {
        super(options)
        this.webgl = webgl
        this.options = options
    
        const suzanneGltf = assets.get(suzanneKey)
        this.suzanneGltf = suzanneGltf
        this.suzanne = suzanneGltf.scene.clone()
    
        const envMap = assets.get(hdrKey)
        this.material = new MeshStandardMaterial({
          envMap,
          roughness: 0.275,
          metalness: 0.422,
        })
    
        this.useHDR = false
        this.backgroundColor = 0xcbe0e7
        this.rotatingBackground = false
    
        this.useGltfTexture = true
        this.useAlbedo = false
        this.useRoughness = false
        this.useMetalness = false
        this.useNormal = false
    
        this.updateMaterialTextures()
    
        addUniforms(this.material, {
          time: { value: 0 },
          frequency: { value: 0.5 },
          amplitude: { value: 0.7 },
          scale: { value: 1 }, // Added scale uniform
          colorShift: { value: 0 } // Added colorShift uniform
        })
    
        customizeVertexShader(this.material, {
          head: glsl`
            uniform float time;
            uniform float frequency;
            uniform float amplitude;
            uniform float scale; // Added scale uniform
          `,
          main: glsl`
            float theta = sin(position.z * frequency + time) * amplitude;
            float c = cos(theta);
            float s = sin(theta);
            mat3 deformMatrix = mat3(c, 0, s, 0, 1, 0, -s, 0, c);
            transformed *= scale; // Apply scaling
          `,
          objectNormal: glsl`
            objectNormal *= deformMatrix;
          `,
          transformed: glsl`
            transformed *= deformMatrix;
          `,
        })
    
        this.suzanne.traverse((child) => {
          if (child.isMesh) {
            child.material = this.material
          }
        })
    
        this.suzanne.scale.multiplyScalar(1.2)
        this.suzanne.position.z = 3
    
        this.speed = 1.5
        this.customRotation = new Vector3(.777, 0, 0)
    
        this.add(this.suzanne)
    
        this.setBackground()
    
        this.webgl.camera.position.z = 5
        this.webgl.camera.fov = 50
        this.webgl.camera.updateProjectionMatrix()
    
        this.textElement = document.createElement('div')
            // Start of Selection
            this.textElement.style.position = 'absolute'
            this.textElement.style.top = '0px'
            this.textElement.style.left = '0px'
            this.textElement.style.transform = 'translate(10px, 10px)'
            this.textElement.style.color = 'white'
            this.textElement.style.fontSize = '48px'
            this.textElement.style.fontFamily = 'Impact, Arial, sans-serif'
            this.textElement.style.textShadow = `
              -2px -2px 0 #000,
              2px -2px 0 #000,
              -2px 2px 0 #000,
              2px 2px 0 #000
            `
            this.textElement.textContent = 'NOTHING ELSE MATTERS'
            this.textElement.style.display = 'none'
        document.body.appendChild(this.textElement)
    
        // Removed GUI initialization
        // this.initGUI()
    
        // Track mouse position
        this.mouseX = 0
        this.mouseY = 0
        // Initialize Raycaster
        this.raycaster = new Raycaster()
        window.addEventListener('mousemove', (event) => {
            this.mouseX = event.clientX
            this.mouseY = event.clientY
            this.textElement.style.left = `${this.mouseX}px`
            this.textElement.style.top = `${this.mouseY}px`

            // Calculate normalized device coordinates
            const mouse = new Vector2(
                (event.clientX / window.innerWidth) * 2 - 1,
                -(event.clientY / window.innerHeight) * 2 + 1
            )
            this.raycaster.setFromCamera(mouse, this.webgl.camera)

            // Determine intersections with Suzanne
            const intersects = this.raycaster.intersectObject(this.suzanne, true)
            if (intersects.length > 0) {
                document.body.style.cursor = 'pointer'
            } else {
                document.body.style.cursor = 'default'
            }
        })
    
        // Add isSecondScene flag to track the current scene state
        this.isSecondScene = false
    
        // Modify window click event to toggle scenes by clicking the glTF
        const handleInteraction = (event) => {
          // Prevent default behavior for touch events
          if (event.type === 'touchstart') {
            event.preventDefault();
          }

          // Use clientX and clientY for both mouse and touch events
          const clientX = event.clientX || (event.touches && event.touches[0].clientX);
          const clientY = event.clientY || (event.touches && event.touches[0].clientY);

          // Calculate normalized device coordinates
          const mouse = new Vector2(
            (clientX / window.innerWidth) * 2 - 1,
            -(clientY / window.innerHeight) * 2 + 1
          )
          this.raycaster.setFromCamera(mouse, this.webgl.camera)

          // Determine intersections with Suzanne
          const intersects = this.raycaster.intersectObject(this.suzanne, true)
          if (intersects.length > 0) {
            if (!this.isSecondScene) {
              // Enter second scene
              this.backgroundColor = 0x54ff3d
              this.rotatingBackground = true
              this.useHDR = false
              this.setBackground()
              this.webgl.camera.position.z = 3.369
              this.textElement.style.display = 'block'
              this.bigTextElement.style.display = 'none' // Hide big text

              // Hide all emojis for the second scene
              this.chatBubbleEmoji.style.display = 'none'
              this.hundredEmoji.style.display = 'none'
              this.cameraEmoji.style.display = 'none'
              this.pillEmoji.style.display = 'none'

              this.isSecondScene = true
            } else {
              // Exit to default scene
              this.textElement.style.display = 'none'
              this.backgroundColor = 0xcbe0e7
              this.rotatingBackground = false
              this.useHDR = false
              this.setBackground()
              this.webgl.camera.position.z = 5

              // Show all emojis in the default scene
              this.chatBubbleEmoji.style.display = 'block'
              this.hundredEmoji.style.display = 'block'
              this.cameraEmoji.style.display = 'block'
              this.pillEmoji.style.display = 'block'

              this.bigTextElement.style.display = 'block' // Show big text

              this.isSecondScene = false
            }
          }
        }

        // Add event listeners for both click and touch events
        window.addEventListener('click', handleInteraction)
        window.addEventListener('touchstart', handleInteraction)
    
        // Optimize text for mobile
        this.updateTextStyle = () => {
          if (window.innerWidth <= 768) {
            this.textElement.style.fontSize = '24px'
            this.textElement.style.top = '60%'
          } else {
            this.textElement.style.fontSize = '48px'
            this.textElement.style.top = '69%'
          }
        }

        this.updateTextStyle()
        window.addEventListener('resize', this.updateTextStyle)
    
        // Add automatic text alternation every 3 seconds
        this.texts = ['NOTHING ELSE MATTERS', '$BDSM']
        this.currentTextIndex = 0
        setInterval(() => {
          this.currentTextIndex = (this.currentTextIndex + 1) % this.texts.length
          this.textElement.textContent = this.texts[this.currentTextIndex]
        }, 3000)
    
        // Add emojis to each corner
        {{
          // Function to create and style an emoji link
          const createEmojiLink = (emoji, position, url) => {
            const link = document.createElement('a')
            link.href = url
            link.textContent = emoji
            link.style.position = 'fixed'
            link.style.fontSize = '32px'
            link.style.textDecoration = 'none'
            link.style.zIndex = '1000'
            
            // Set position
            if (position.top !== undefined) link.style.top = position.top + 'px'
            if (position.bottom !== undefined) link.style.bottom = position.bottom + 'px'
            if (position.left !== undefined) link.style.left = position.left + 'px'
            if (position.right !== undefined) link.style.right = position.right + 'px'
            
            document.body.appendChild(link)
            return link
          }

          // Create emoji links with positions
          this.chatBubbleEmoji = createEmojiLink('💬', { top: 10, left: 10 }, 'https://t.me/inretrospectitwasinevitable')
          this.hundredEmoji = createEmojiLink('💯', { top: 10, right: 10 }, 'https://x.com/sol_shitter')
          this.cameraEmoji = createEmojiLink('📷', { bottom: 10, left: 10 }, 'https://meme.blliondollarsolana.meme')
          this.pillEmoji = createEmojiLink('💫', { bottom: 10, right: 10 }, 'https://dexscreener.com/solana/hpucjgxgowngfugb2a2egnhddbdokolpshnurzezipjo')
        }}
    
        // Add rotating big text elements
        {{ 
          // Define the big words to display
          this.bigWords = ['BILLION', 'DOLLAR', 'SOLANA', 'MEME']
          this.currentBigWordIndex = 0

          // Create a text element for big words
          this.bigTextElement = document.createElement('div')
          this.bigTextElement.style.position = 'absolute'
          this.bigTextElement.style.top = '50%'
          this.bigTextElement.style.left = '50%'
          this.bigTextElement.style.transform = 'translate(-50%, -50%)'
          this.bigTextElement.style.color = 'white'
          this.bigTextElement.style.fontSize = '100px'
          this.bigTextElement.style.fontWeight = 'bold'
          this.bigTextElement.style.textAlign = 'center'
          this.bigTextElement.style.display = 'none'
          document.body.appendChild(this.bigTextElement)

          // Function to show next big word
          this.showNextBigWord = () => {
            if (!this.isSecondScene) { // Only show big text in the default scene
              this.bigTextElement.textContent = this.bigWords[this.currentBigWordIndex]
              this.bigTextElement.style.display = 'block'

              setTimeout(() => {
                this.bigTextElement.style.display = 'none'
                this.currentBigWordIndex = (this.currentBigWordIndex + 1) % this.bigWords.length
              }, 3000) // Display each word for 3 seconds
            }
          }

          // Start cycling big words immediately and adjust interval for proper cycling
          this.showNextBigWord(); // Show the first word immediately

          setInterval(() => {
            this.showNextBigWord();
          }, 6000) // Cycle every 6 seconds (3s display, 3s hide)
        }}
      }
    
      setBackground() {
        if (this.useHDR) {
          this.webgl.scene.background = assets.get(hdrKey)
        } else {
          this.webgl.scene.background = new Color(this.backgroundColor)
        }
      }
    
      updateMaterialTextures() {
        if (this.useGltfTexture) {
          const gltfMaterial = this.suzanneGltf.scene.children[0].material
          this.material.map = gltfMaterial.map
          this.material.roughnessMap = gltfMaterial.roughnessMap
          this.material.metalnessMap = gltfMaterial.metalnessMap
          this.material.normalMap = gltfMaterial.normalMap
        } else {
          this.material.map = this.useAlbedo ? assets.get(albedoKey) : null
          this.material.roughnessMap = this.useRoughness ? assets.get(roughnessKey) : null
          this.material.metalnessMap = this.useMetalness ? assets.get(metalnessKey) : null
          this.material.normalMap = this.useNormal ? assets.get(normalKey) : null
          this.material.normalScale = this.useNormal ? new Vector2(2, 2) : new Vector2(1, 1)
        }
        this.material.needsUpdate = true
      }
    
      // Removed initGUI method
      // initGUI() {
      //     const gui = new GUI()
      // 
      //     const materialFolder = gui.addFolder('Material')
      //     materialFolder.add(this.material, 'roughness', 0, 1)
      //     materialFolder.add(this.material, 'metalness', 0, 1)
      // 
      //     const texturesFolder = gui.addFolder('Textures')
      //     texturesFolder.add(this, 'useGltfTexture').name('Use glTF Texture').onChange(() => this.updateMaterialTextures())
      //     texturesFolder.add(this, 'useAlbedo').onChange(() => this.updateMaterialTextures())
      //     texturesFolder.add(this, 'useRoughness').onChange(() => this.updateMaterialTextures())
      //     texturesFolder.add(this, 'useMetalness').onChange(() => this.updateMaterialTextures())
      //     texturesFolder.add(this, 'useNormal').onChange(() => this.updateMaterialTextures())
      // 
      //     const lightingFolder = gui.addFolder('Lighting')
      //     lightingFolder.add(this, 'useHDR').name('Use HDR').onChange(() => this.setBackground())
      //     lightingFolder.addColor(this, 'backgroundColor').name('Background Color').onChange(() => {
      //         if (!this.useHDR) this.setBackground()
      //     })
      // 
      //     const movementFolder = gui.addFolder('Movement')
      //     movementFolder.add(this.material.uniforms.frequency, 'value', 0, 2).name('Frequency')
      //     movementFolder.add(this.material.uniforms.amplitude, 'value', 0, 2).name('Amplitude')
      //     movementFolder.add(this, 'speed', 0, 5)
      // 
      //     const rotationFolder = gui.addFolder('Rotation')
      //     rotationFolder.add(this.customRotation, 'x', 0, Math.PI * 2)
      //     rotationFolder.add(this.customRotation, 'y', 0, Math.PI * 2)
      //     rotationFolder.add(this.customRotation, 'z', 0, Math.PI * 2)
      // 
      //     const cameraFolder = gui.addFolder('Camera')
      //     cameraFolder.add(this.webgl.camera.position, 'x', -10, 10)
      //     cameraFolder.add(this.webgl.camera.position, 'y', -10, 10)
      //     cameraFolder.add(this.webgl.camera.position, 'z', -10, 10)
      //     cameraFolder.add(this.webgl.camera, 'fov', 10, 120).onChange(() => this.webgl.camera.updateProjectionMatrix())
      // }
    
      update(dt, time) {
        if (this.rotatingBackground) {
          const hsl = { h: 0, s: 0, l: 0 }
          this.webgl.scene.background.getHSL(hsl)
          
          // Map mouse X to hue and mouse Y to saturation for dynamic coloring
          hsl.h = this.mouseX / window.innerWidth // Hue based on horizontal mouse position
          hsl.s = this.mouseY / window.innerHeight // Saturation based on vertical mouse position
          hsl.l = 0.5 // Maintain constant lightness for brightness
          
          this.webgl.scene.background.setHSL(hsl.h, hsl.s, hsl.l)
        }
  
        // Calculate mouse proximity to screen center
        const centerX = window.innerWidth / 2
        const centerY = window.innerHeight / 2
        const dx = this.mouseX - centerX
        const dy = this.mouseY - centerY
        const distance = Math.sqrt(dx * dx + dy * dy)
        const maxDistance = Math.sqrt(centerX * centerX + centerY * centerY)
        const proximity = 1 - Math.min(distance / maxDistance, 1) // Closer = higher proximity
  
        // Adjust metalness and roughness based on proximity
        this.material.metalness = proximity // More metallic when closer
        this.material.roughness = 1 - proximity // Less rough when closer
  
        // Update uniforms for effects
        this.material.uniforms.time.value += dt * this.speed
        this.material.uniforms.scale.value = 1 + 0.3 * Math.sin(this.material.uniforms.time.value) // Pulsating scale
        this.material.uniforms.colorShift.value = (this.material.uniforms.time.value * 0.1) % 1.0 // Color shift
  
        // Update Suzanne rotation
        const wobble = Math.sin(this.material.uniforms.time.value) * 0.1
        this.suzanne.rotation.set(
          this.customRotation.x + wobble,
          this.customRotation.y + wobble,
          this.customRotation.z + wobble
        )
  
        // Slight rotation based on mouse position
        this.suzanne.rotation.x += (this.mouseY / window.innerHeight - 0.5) * .5
        this.suzanne.rotation.y += (this.mouseX / window.innerWidth - 0.5) * 10
      }
    }